// Puerto del dominio (repository abstracto) para el catálogo
import { Observable } from 'rxjs';
import { CirculationZone, Country } from '../../interfaces/catalog/catalog.interface';

export abstract class CatalogRepository {
  abstract getCountries(): Observable<Country[]>;
  abstract getCirculationZones(): Observable<CirculationZone[]>;
}
